import styled from "styled-components";

export const Title = styled.div`
  padding: 0 20px;
  min-width: 15%;
`;
